import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import Quote from 'models/quote';
import { Location } from 'models/locations';
import Event from 'models/event';
import Venue from 'models/venue';

import EventContent from 'components/venue/events/event-link/event-content';

const propTypes = {
  selectedQuote: PropTypes.instanceOf(Quote),
  selectedLocation: PropTypes.instanceOf(Location),
  event: PropTypes.instanceOf(Event),
  venue: PropTypes.instanceOf(Venue),
};

const defaultProps = {
  selectedQuote: new Quote(),
  selectedLocation: new Location(),
  event: null,
  venue: null,
};

export const CheckoutSubHeadline = ({ selectedQuote, selectedLocation, event, venue }) => {
  if (get(selectedQuote, 'isMonthly')) {
    return (
      <div className="text-color-dark-slate text-size-16">
        <div className="text-weight-bold text-size-14 margin-bottom-10">
          {get(selectedQuote, 'name')}
        </div>
        <div className="text-weight-medium hidden-xs">
          {get(selectedLocation, 'address1')} - {get(selectedLocation, 'name')}
        </div>
      </div>
    );
  }

  if (event) {
    return (
      <EventContent event={event} venue={venue} />
    );
  }

  return (
    <div className="text-color-dark-slate text-size-16 text-weight-book">
      <div className="text-weight-bold hidden-xs">
        {get(selectedLocation, 'address1')} - {get(selectedLocation, 'name')}
      </div>
    </div>
  );
};

CheckoutSubHeadline.propTypes = propTypes;
CheckoutSubHeadline.defaultProps = defaultProps;

export default CheckoutSubHeadline;
